import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import type GoalActivity from 'linced-app/models/coach/goal-activity';

// Proto: coach.GoalPlan.
export default class GoalPlan extends Model {
  declare [Type]: 'coach/goal-plan';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // promptHash is a sha256sum of the combination of "jurisdiction;academicLevel;prompt"
  // to enable quick search for previously processed prompts.
  @attr('string', { defaultValue: '' })
  declare promptHash: string;

  // jurisdiction is the educational jurisdiction the goal plan relates to.
  @attr('number', { defaultValue: 0 })
  declare jurisdiction: EnumValue<typeof Jurisdiction> | 0;

  // academicLevel is the academic year level the goal plan relates to.
  @attr('string', { defaultValue: '' })
  declare academicLevel: string;

  // subject is the school subject the goal plan relates to.
  @attr('string', { defaultValue: '' })
  declare subject: string;

  // goal contains the goal description to build a goal plan for.
  // Note: this incoming data from this field is removed to reduce stored data
  // in favour of hashing the generated prompt.
  @attr('string', { defaultValue: '' })
  declare goal: string;

  @attr('string', { defaultValue: '' })
  declare goalId: string;

  // activities provides a list of suggested learning activities.
  @fragmentArray('coach/goal-activity')
  declare activities: FragmentArray<GoalActivity>;
}
